module.exports = __webpack_public_path__ + "static/media/fhs-earn-active.96ada7be.png";